<script setup>

    import { onBeforeMount } from 'vue';

    onBeforeMount(() => {
        addTypeBotHelper();
    });
    const addTypeBotHelper = () => {
        Typebot.initBubble({
            typebot: "abertura-ticket",
            apiHost: "https://typechat.deppes.com",
            previewMessage: {
                message: "Precisa de ajuda? Fale com nosso time!",
                autoShowDelay: 3000,
                avatarUrl: "https://storage.deppes.com/typebot/public/workspaces/clvpbzhua00015aq54q9f0wtc/typebots/cm9abd4i1000112tsmfzlvyte/hostAvatar?v=1744228132750",
            },
            theme: { button: { backgroundColor: "#4361ee" } },
        });
    };
</script>

<template></template>
